import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, FileText, Bell, User } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

interface TabNavigationProps {
    className?: string;
}

const tabs = [
    { to: '/', label: 'Trang chủ', icon: Home },
    { to: '/notes', label: 'Ghi Chú', icon: FileText },
    { to: '/notifications', label: 'Thông Báo', icon: Bell },
];

const TabNavigation: React.FC<TabNavigationProps> = ({ className = '' }) => {
    const { isAuthenticated, user, openAuthModal } = useAuthStore();

    return (
        <nav className={`hidden md:flex items-center justify-center gap-1 bg-white/80 backdrop-blur-sm rounded-full px-2 py-1 shadow-md ${className}`}>
            {tabs.map((tab) => (
                <NavLink
                    key={tab.to}
                    to={tab.to}
                    className={({ isActive }) =>
                        `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all
                        ${isActive
                            ? 'bg-blue-500 text-white shadow-sm'
                            : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                        }`
                    }
                >
                    <tab.icon className="w-4 h-4" />
                    <span>{tab.label}</span>
                </NavLink>
            ))}

            {/* Account button */}
            <div className="ml-2 pl-2 border-l border-gray-200">
                {isAuthenticated && user ? (
                    <NavLink
                        to="/account"
                        className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-all"
                    >
                        {user.avatarUrl ? (
                            <img src={user.avatarUrl} alt="" className="w-6 h-6 rounded-full" />
                        ) : (
                            <User className="w-4 h-4" />
                        )}
                        <span className="max-w-[100px] truncate">{user.name || user.email}</span>
                    </NavLink>
                ) : (
                    <button
                        onClick={openAuthModal}
                        className="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium bg-blue-500 text-white hover:bg-blue-600 transition-all"
                    >
                        <User className="w-4 h-4" />
                        <span>Đăng nhập</span>
                    </button>
                )}
            </div>
        </nav>
    );
};

export default TabNavigation;

